@for (elementoMenu of elementosMenu; track elementoMenu) {
  <div class="flex px-4 py-2 cursor-pointer hover:bg-indigo-50 hover:rounded-full select-none"
    role="button" tabindex="0"
    (click)="abrirPanelMenuONavegar(elementoMenu)"
    (keydown.enter)="$event.preventDefault(); abrirPanelMenuONavegar(elementoMenu)"
    (keydown.space)="$event.preventDefault(); abrirPanelMenuONavegar(elementoMenu)"
    [ngClass]="{'bg-indigo-50 rounded-full transition-all duration-200 text-indigo-600 shadow-xs': rutaVisible(elementoMenu)}">
    <img [src]="'assets/img/iconos/' + elementoMenu.icono" alt="" height="20" width="20">
    @if (elementoMenu.ruta !== '') {
      <p
        class="text-sm font-medium leading-6 text-black-500 w-full ml-2">
        {{ elementoMenu.titulo }}
      </p>
    }
    @if (elementoMenu.ruta === '') {
      <span
        class="text-sm font-medium leading-6 text-black-500 w-full ml-2">
        {{ elementoMenu.titulo }}
      </span>
    }
    @if (elementoMenu.elementosHijos.length > 0) {
      <img
        [src]="menuActivo === elementoMenu
            ? 'assets/img/iconos/chevron-up.svg'
            : 'assets/img/iconos/chevron-down.svg'"
        [alt]="menuActivo === elementoMenu
            ? 'Flecha hacia arriba, opcion abierta'
            : 'Flecha hacia abajo, opcion cerrada'"
        height="15" width="15" class="ml-2"
        />
    }
  </div>
}
